export const CREATE_QUERY_PARAM = "create";

export const MODULE_LIST_PATHS = {
  vehicle: { fleet: "/Vehicle", school: "/school-vehicles" },
  stop: { fleet: "/stop", school: "/school-stops" },
  route: { fleet: "/route", school: "/school-routes" },
};

export function isSchoolAppPath(pathname = "") {
  return String(pathname).startsWith("/school");
}

export function getModuleListPath(module, isSchool = false) {
  const paths = MODULE_LIST_PATHS[module];
  if (!paths) return "/";
  return isSchool ? paths.school : paths.fleet;
}

export function getModuleCreatePath(module, isSchool = false) {
  return `${getModuleListPath(module, isSchool)}?${CREATE_QUERY_PARAM}=1`;
}

export function readCreateIntent(location) {
  const params = new URLSearchParams(location?.search || "");
  const state = location?.state && typeof location.state === "object" ? location.state : {};
  const primitiveStateId =
    location?.state && typeof location.state !== "object" ? location.state : null;

  return {
    openCreate:
      params.get(CREATE_QUERY_PARAM) === "1" || Boolean(state.openCreate),
    expandId:
      state.expandId ||
      state.id ||
      state.vehicleId ||
      state.stopId ||
      state.routeId ||
      state.rowData?.id ||
      params.get("expand") ||
      primitiveStateId ||
      null,
  };
}

export function clearCreateIntent(navigate, location) {
  const params = new URLSearchParams(location?.search || "");
  const hadIntent =
    params.has(CREATE_QUERY_PARAM) ||
    params.has("expand") ||
    Boolean(location?.state?.openCreate) ||
    Boolean(location?.state?.expandId) ||
    Boolean(location?.state?.id);

  if (!hadIntent) return;

  params.delete(CREATE_QUERY_PARAM);
  params.delete("expand");
  const search = params.toString();
  navigate(
    {
      pathname: location.pathname,
      search: search ? `?${search}` : "",
    },
    { replace: true, state: {} },
  );
}
